import { render, staticRenderFns } from "./AiaAgreement.vue?vue&type=template&id=7c34e70b&scoped=true"
import script from "./AiaAgreement.vue?vue&type=script&lang=js"
export * from "./AiaAgreement.vue?vue&type=script&lang=js"
import style0 from "./AiaAgreement.vue?vue&type=style&index=0&id=7c34e70b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c34e70b",
  null
  
)

export default component.exports